import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface Club {
  id: string;
  name: string;
  location: string | null;
  organization_id: string;
  profile_picture_url: string | null;
  sport: string | null;
  website: string | null;
  created_at: string | null;
}

export const useOrganizationClubs = (organizationId: string | undefined) => {
  const { data: clubs = [], isLoading, error } = useQuery({
    queryKey: ['organization-clubs', organizationId],
    queryFn: async () => {
      if (!organizationId) return [];
      
      const { data, error } = await supabase
        .from('clubs')
        .select('*')
        .eq('organization_id', organizationId)
        .order('name');
      
      if (error) throw error;
      return data as Club[];
    },
    enabled: !!organizationId,
  });

  return {
    clubs,
    isLoading,
    error,
  };
};